import { Palette } from '../types'
import { http } from './http'

export const fetchCompanyPalettes = async (): Promise<Palette[]> => {
  const { data } = await http.get<Palette[]>(`/v2/palettes`)
  return data
}
